"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { AuthHeading, AuthLayout, StatusPanel } from "@/components/auth-ui";
import { SignInForm } from "@/components/sign-in-form";
import { safeNextPath } from "@/lib/navigation";

/* Client half of /sign-in. The app badges are a server component passed in
   from the page, so the store links are not part of client config. */
export function SignInScreen({ appBadges }: { appBadges: React.ReactNode }) {
  const [justRegistered, setJustRegistered] = useState(false);
  const [nextPath, setNextPath] = useState("/dashboard");
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setJustRegistered(params.get("registered") === "1");
    setNextPath(safeNextPath(params.get("next")));
  }, []);

  return <AuthLayout variant="sign-in" size="narrow">
    <AuthHeading title="Welcome back">Sign in to your facility portal.</AuthHeading>
    {justRegistered && <StatusPanel tone="success" title="Password saved">Sign in with your new password to finish registering your facility.</StatusPanel>}
    <SignInForm nextPath={nextPath} footer={<p className="auth-switch divided"><span>New to Facility360?</span><Link href="/sign-up/verify">Register your facility</Link></p>} />
    {appBadges}
  </AuthLayout>;
}
